module.exports = __webpack_public_path__ + "img/p-3.cc3e3d58.png";